<template>
    <div>
      <el-card class="box-card" style="margin: 40px;">
        <div slot="header" class="clearfix">
          <span>权限管理</span>
          <el-button style="float: right;" @click="updateqx" type="success" icon="el-icon-edit" >更新</el-button>
          <el-button style="float: right; margin-right: 10px;" @click="queryuser" type="success" icon="el-icon-edit" >查看</el-button>
        </div>
        <div class="text item">
          <div class="source">
            <el-row class="querypanel">
              <el-col :span="24">
                <div class="leftpanel">
                  <div>用户权限列表:</div>
                  <el-tree
                    class="filter-tree"
                    node-key="id"
                    accordion
                    default-expand-all
                    ref="gt_tree_list"
                    :data="gt_usergroupsdata"
                    :props="gt_defaultProps"
                    :check-strictly = "true"
                    :expand-on-click-node="false"
                    :render-content="gt_renderugcontext">
                  </el-tree>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
      <el-dialog title="用户列表" :visible.sync="userlistvisible" >
        <el-table
          stripe
          highlight-current-row
          :data="userdata"
          ref="multipleTable">
          <el-table-column
            prop="username"
            width = "200px"
            label="账号">
          </el-table-column>
          <el-table-column
            prop="password"
            label="密码">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="选定" placement="top-start">
                <i class="fa fa-check-square-o opicon fa-lg curpointer" v-on:click="selectuser(scope.$index, userdata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import { Message } from 'element-ui'
  import '../../../static/css/my.css'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'JsonChange',
    mounted: function () {
      console.log('mounted')
      var v = getCookie('cusid')
      this.khid = v
      that = this
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
      }
    },
    data () {
      return {
        userlistvisible: false,
        userdata: [],
        curmodes: '',
        gt_usergroupsdata: [],
        gt_typeid: '',
        khid: '',
        gt_selectnode: [],
        loading: false,
        curuserid: '',
        typeattr: '',
        gt_defaultProps: {
          children: 'Children',
          label: 'Name'
        }
      }
    },
    methods: {
      updateqx () {
        var updatas = []
        var updata = {
          userid: parseInt(this.curuserid),
          models: JSON.stringify(that.gt_usergroupsdata)
        }
        updatas.push(updata)
        that.$http({
          url: 'https://api.sqnetsoft.cn/permission/papu',
          method: 'post',
          data: updatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.success) {
              Message.success('更新完毕')
            } else {
              Message.error('更新失败')
            }
          })
          .catch(function (error) {
            Message.error('更新失败')
            console.log('error' + error)
          })
      },
      selectuser(index,data) {
        this.userlistvisible = false
        window.console.log(data[index])
        this.curuserid = data[index].id.Int64
        var qstr = 'user_id = ' + data[index].id.Int64
        this.$http({
          url: 'https://api.sqnetsoft.cn/permission/gpu',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              var tmpdata = JSON.parse(res.data.data)
              that.gt_usergroupsdata = JSON.parse(tmpdata[0].models)
              that.curmodes = tmpdata[0].models
            } else {
              Message.error('用户名或密码错误')
            }
          })
          .catch(function (error) {
            Message.error('权限获取失败')
            console.log('error' + error)
          })
      },
      queryuser () {
        this.userlistvisible = true
        that.$options.methods.queryuserlist()
      },
      queryuserlist () {
        var qstr = 'id > 0'
        that.$http({
          url: 'https://api.sqnetsoft.cn/account/getaccountlist',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.success) {
              that.userdata = JSON.parse(res.data.data)
            } else {
              Message.error('用户名或密码错误')
            }
          })
          .catch(function (error) {
            Message.error('服务器无法登陆')
            console.log('error' + error)
          })
      },
      gt_renderugcontext (h, { node, data, store }) {
        return (
          <div class="treerow">
          {
              (data.level === 0) ? <span> {data.Name} </span>: <div class="treerow"><i style="margin-right: 10px;" class="fa fa-outdent gtopicon" on-click={ () => this.addline(node, data)}> </i><input type="text" on-change={ () => this.blurnametxt(node, data,event)} class="el-input__inner treerowinput" value={data.Name} /> <input type="text" on-change={ () => this.blurlinktxt(node, data, event)} class="el-input__inner treerowinput" value={data.ModelUrl.String} /> <span class="treeop"> <i class="fa fa-chevron-up gtopicon" on-click={ () => this.gt_up(node, data)}> </i> <i class="fa fa-chevron-down gtopicon" on-click={ () => this.gt_down(node, data)}> </i> <i class="fa fa-trash-o gtopicon" on-click={ () => this.gt_remove(node, data)}> </i> </span> </div>
          }
          </div>
      )
      },
      addline (node, data) {
        window.console.log(node,data)
        var nodedata = {
          AppID: data.AppID,
          Children: [],
          HasChild: 0,
          Icon: {'String': '','Vaild':true},
          Id: (data.Level*100 + 10 + parseInt(data.Id) + data.Children.length).toString(),
          Leaf: 'true',
          Level: parseInt(data.Level) + 1,
          Name: '',
          ModelUrl: {'String': '','Vaild':true},
          ParentID: data.Id.toString()
        }
        window.console.log(nodedata)
        data.Children.push(nodedata)
      },
      blurnametxt (node, data, event) {
        data.Name = event.target.value
        localStorage.setItem('curmodels', JSON.stringify(that.gt_usergroupsdata))
        that.gt_usergroupsdata = JSON.parse(localStorage.getItem('curmodels'))
        Message.success('已保存')
      },
      blurlinktxt (node, data, link) {
        Message.success('已保存')
        data.ModelUrl = {'String': event.target.value ,'Vaild':true}
        localStorage.setItem('curmodels', JSON.stringify(that.gt_usergroupsdata))
        that.gt_usergroupsdata = JSON.parse(localStorage.getItem('curmodels'))
        Message.success('已保存')
      },
      gt_remove (node, data) {
        console.log(node,data)
        for (var i = 0; i< node.parent.data.Children.length; i++) {
          var tmpdata = node.parent.data.Children[i]
          if (tmpdata.Id === data.Id) {
            node.parent.data.Children.splice(i,1)
          }
        }
      },
      gt_up (node, data) {
        for (var i = 0; i< node.parent.data.Children.length; i++) {
          var tmpdata = node.parent.data.Children[i]
          if (tmpdata.Id === data.Id) {
            if (i === 0) {
              Message.info('已经是第一个了')
            } else {
              var tmpchild = node.parent.data.Children
              var sourcedata = tmpchild[i]
              var olddata = tmpchild[i-1]
              node.parent.data.Children.splice(i - 1, 1, sourcedata)
              node.parent.data.Children.splice(i, 1, olddata)
            }
          }
        }
        localStorage.setItem('curmodels', JSON.stringify(that.gt_usergroupsdata))
        that.gt_usergroupsdata = JSON.parse(localStorage.getItem('curmodels'))
      },
      gt_down (node, data) {
        for (var i = 0; i < node.parent.data.Children.length; i++) {
          var tmpdata = node.parent.data.Children[i]
          if (tmpdata.Id === data.Id) {
            if (i === node.parent.data.Children.length - 1) {
              Message.info('已经是最后一个了')
            } else {
              var tmpchild = node.parent.data.Children
              var sourcedata = tmpchild[i]
              var olddata = tmpchild[i + 1]
              node.parent.data.Children.splice(i + 1, 1, sourcedata)
              node.parent.data.Children[i] = olddata
              localStorage.setItem('curmodels', JSON.stringify(that.gt_usergroupsdata))
              that.gt_usergroupsdata = JSON.parse(localStorage.getItem('curmodels'))
              return;
              // node.parent.data.Children.splice(i + 1, 1, sourcedata)
            }
          }
        }
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style>
  .gtopicon {
    font-size: 14px;
    padding-left: 15px;
  }
  .treerow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .treerowinput {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-right: 8px;
    width:200px;
  }
  .treeop {
    flex: 1;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: flex-end;
  }
  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/jsoncl/JsonChange.vue